<template>
    <div class="body">
        <van-image
            width="30vw"
            height="30vw"
            :src="img"
        />
        <div class="title">
            未找到相关内容
        </div>
    </div>
</template>

<script>
export default {
    name: 'Empty',
    setup() {
        // init imgMap
        const baseUrl = '/resource/components/'
        const img = baseUrl + 'empty.jpg'

        return {
            img
        }
    }
}
</script>

<style scoped>
.body {
    width: 100%;
    text-align: center;
}

.title {
    color: #4E4E4E;
    margin-top: 30px;
}
</style>
